import React, { useEffect } from "react";
import {
  BetaForm as useBetaForm,
  TextInputBase,
  ButtonBase,
} from "@reusejs/react";
import { useSelector } from "react-redux";
import ResendCode from "./ResendCode";

export interface ManualVerificationProps {
  handleManualVerification?: any;
  handleResendCode?: any;
}

export default function ManualVerification(props: ManualVerificationProps) {
  const guestUser = useSelector((state: any) => {
    return state.auth.guestUser;
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    token: {
      presence: {
        allowEmpty: false,
        message: "^OTP can't be blank",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const form = useBetaForm({
    email: guestUser?.email ? guestUser.email : "",
    token: "",
  });

  const hanldeSubmit = () => {
    try {
      if (form.validate()) {
        props.handleManualVerification(form);
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };

  const handleResendCode = () => {
    try {
      props.handleResendCode(form);
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return (
    <div>
      <div className="">
        <TextInputBase
          name={"token"}
          onChange={(val) => form.setField("token", val)}
          placeholder={"Enter your otp"}
          type={"text"}
          error={
            form.errors.get("token") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("token")[0]}
              </p>
            ) : null
          }
          value={form.getField("token")}
          htmlFor={"token"}
        />
      </div>
      <div className="mt-4">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Verify email"
          onClick={hanldeSubmit}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />
      </div>

      <div className="py-5 text-sm text-gray-600">
        Didn’t receive the email?{" "}
        <ResendCode resendCallback={handleResendCode} />
      </div>
    </div>
  );
}
